import React, { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import ConditionalWrapper from 'components/ConditionalWrapper';
import CSSTransitionWrapper from 'components/CSSTransitionWrapper';
import Input from 'components/Inputs/Input';
import Select from 'components/Select';
import styles from 'pages/ContractorPortal/steps/ContractorApplication/ContractorApplication.module.scss';
import {
  DEFAULT_REQUIRED_MESSAGE,
  HOLD_LICENSE_OPTIONS,
} from 'pages/ContractorPortal/steps/ContractorApplication/сontractorApplication.constants';
import {
  HoldLicense,
  InputLabel,
} from 'pages/ContractorPortal/steps/ContractorApplication/contractorApplication.enums';

const HoldAppropriateLicense = () => {
  const {
    register,
    unregister,
    setValue,
    control,
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();
  const watcher = watch();
  const isLicenseDescriptionDisplayed = watcher.intermediary_hold_appropriate_license === HoldLicense.No;

  useEffect(() => {
    register('intermediary_hold_appropriate_license', {
      required: {
        value: !watcher.intermediary_hold_appropriate_license,
        message: DEFAULT_REQUIRED_MESSAGE,
      },
    });
    register('intermediary_hold_appropriate_license_description', {
      required: {
        value: isLicenseDescriptionDisplayed && !watcher.intermediary_hold_appropriate_license_description,
        message: DEFAULT_REQUIRED_MESSAGE,
      },
    });
  }, [register, unregister, watcher, isLicenseDescriptionDisplayed]);

  return (
    <>
      <div className={styles.form_row}>
        <Select
          label={InputLabel.LicenseContractingServices}
          name="intermediary_hold_appropriate_license"
          required
          options={HOLD_LICENSE_OPTIONS}
          errorMessage={errors?.intermediary_hold_appropriate_license?.message}
          inputContainerClassName={styles.input}
          className={styles.dropdown}
          useFormControl
          control={control}
          isClearable={!!watcher.intermediary_hold_appropriate_license}
          value={HOLD_LICENSE_OPTIONS.find((option) => option.label === watcher.intermediary_hold_appropriate_license)}
        />
      </div>
      <ConditionalWrapper
        condition={isLicenseDescriptionDisplayed}
        wrapper={(children) => (
          <CSSTransitionWrapper trigger={isLicenseDescriptionDisplayed}>{children}</CSSTransitionWrapper>
        )}
      >
        {isLicenseDescriptionDisplayed && (
          <div className={styles.form_row}>
            <Input
              name="intermediary_hold_appropriate_license_description"
              label={InputLabel.ExplainSpecificLicense}
              onChange={(event) => {
                setValue('intermediary_hold_appropriate_license_description', event.target.value);
                trigger('intermediary_hold_appropriate_license_description');
              }}
              value={watcher.intermediary_hold_appropriate_license_description}
              errorMessage={errors?.intermediary_hold_appropriate_license_description?.message}
            />
          </div>
        )}
      </ConditionalWrapper>
    </>
  );
};

export default HoldAppropriateLicense;
